import Vue from "vue";
import { createRouter, createWebHistory } from "vue-router";

import LoginComponent from "../components/login-component";
import RequestPasswordResetComponent from "../components/request-password-reset-component";
import RequestPasswordResetConfirmationComponent from "../components/request-password-reset-confirmation-component";
import PasswordResetComponent from "../components/password-reset-component";

import AgreeToProceedComponent from "../components/agree-to-proceed-component";
import PolicyAndAcceptanceComponent from "../components/policy-and-acceptance-component";
import YourDashboardComponent from "../components/your-dashboard-component";
import YourProfileFactoryComponent from "@/components/your-profile-factory-component.vue";
import VehicleSearchComponent from "../components/vehicle-search-component";
import CarComparisonComponent from "../components/car-comparison/car-comparison-component";
import ConfigureVehicleComponent from "../components/configure-vehicle-component";

import SalarySacrificeOrderProcessComponent from "../components/order-process/salsac/order-process-component";
import SalarySacrificePersonalDetailsComponent from "../components/order-process/salsac/personal-details-component";
import SalarySacrificeProductDetailsComponent from "../components/order-process/salsac/product-details-component";
import SalarySacrificeOrderDetailsComponent from "../components/order-process/salsac/order-details-component";

import EcoAmapsOrderProcessComponent from "../components/order-process/ecoamaps/order-process-component";
import EcoAmapsPersonalDetailsComponent from "../components/order-process/ecoamaps/personal-details-component";
import EcoAmapsProductDetailsComponent from "../components/order-process/ecoamaps/product-details-component";
import EcoAmapsOrderDetailsComponent from "../components/order-process/ecoamaps/order-details-component";

import BchOrderProcessComponent from "../components/order-process/bch/order-process-component";
import BchPersonalDetailsComponent from "../components/order-process/bch/personal-details-component";
import BchProductDetailsComponent from "../components/order-process/bch/product-details-component";
import BchOrderDetailsComponent from "../components/order-process/bch/order-details-component";

import FAQsComponent from "../components/faqs-component";
import OrderStatusComponent from "../components/order-status/order-status-component";
import MyDetailsAndDocumentsComponent from "../components/my-details-and-documents-component";
import ViewAndCompareYourShortlistedVehiclesComponent from "../components/view-and-compare-your-shortlisted-vehicles-component";
import CalculatorComponent from "../components/calculator-component";
import MyVehicleComponent from "../components/my-vehicle/my-vehicle-component";

import ReplacementQuotesComponent from "../components/replacement-quotes";
import AdfsPostflightComponent from "../components/adfs-postflight-component.vue";

const routes = [
    // Welcome to Origo (Login)
    {
        path: "/login",
        name: "Login",
        component: LoginComponent,
        meta: {
            title: "Welcome to Origo",
            hideHeader: true,
            hideFooter: true,
        },
    },

    {
        path: "/adfs-postflight",
        name: "ADFS Postflight",
        component: AdfsPostflightComponent,
        meta: {
            title: "Preparing data",
            hideHeader: true,
            hideFooter: true,
        },
    },

    // Request Password Reset
    {
        path: "/request-password-reset",
        name: "Request Password Reset",
        component: RequestPasswordResetComponent,
        meta: {
            title: "Request Password Reset",
            hideHeader: true,
            hideFooter: true,
        },
    },

    // Request Password Reset Confirmation
    {
        path: "/request-password-reset-confirmation",
        name: "Request Password Reset Confirmation",
        component: RequestPasswordResetConfirmationComponent,
        meta: {
            title: "Request Password Reset Confirmation",
            hideHeader: true,
            hideFooter: true,
        },
    },

    // Password Reset
    {
        path: "/password-reset",
        name: "Password Reset",
        component: PasswordResetComponent,
        meta: {
            title: "Password Reset",
            hideHeader: true,
            hideFooter: true,
        },
    },

    // Agree to Proceed (EULA)
    {
        path: "/agree-to-proceed",
        name: "Agree to Proceed",
        component: AgreeToProceedComponent,
        meta: {
            title: "Policies - Origo",
            nextPage: {
                title: "Continue",
                name: "policy-and-acceptance",
            },
            hideStage: true,
        },
    },

    // Policy & Acceptance
    {
        path: "/policy-and-acceptance",
        name: "policy-and-acceptance",
        component: PolicyAndAcceptanceComponent,
        meta: {
            title: "Policy and Acceptance - Origo",
            nextPage: {
                title: "Continue",
                name: "Your Dashboard",
            },
        },
    },

    // Your Dashboard (Driver Landing Page)
    {
        path: "/your-dashboard",
        name: "Your Dashboard",
        component: YourDashboardComponent,
        meta: {
            title: "Your Dashboard - Origo",
            hideFooter: true,
            nextPage: {
                title: "Continue",
                name: "Your Profile",
            },
        },
    },

    // Your Profile (Details Check)
    {
        path: '/:scheme/your-profile',
        name: 'Your Profile',
        component: YourProfileFactoryComponent,
        meta: {
            title: "Your Profile - Origo",
        },
    },

    // Shortlist
    {
        path: "/:scheme/shortlist",
        name: "Shortlist",
        component: VehicleSearchComponent,
        meta: {
            title: "Shortlist",
        },
    },

    // Car Comparison
    {
        path: "/:scheme/car-comparison",
        name: "Car Comparison",
        component: CarComparisonComponent,
        meta: {
            title: "Car Comparison - Origo",
            nextPage: {
                title: "Order selected car",
            },
        },
    },

    // Configure Vehicle
    {
        path: "/:scheme/configure-vehicle/shortlist/:shortListId/quote/:quoteId",
        name: "Configure Vehicle",
        component: ConfigureVehicleComponent,
        meta: {
            title: "Configure Vehicle - Origo",
        },
    },

    // Salary Sacrifice Order Process
    {
        path: "/salsac/order-process/:quoteId",
        name: "Salary Sacrifice Order Process",
        component: SalarySacrificeOrderProcessComponent,

        children: [
            // Personal Details
            {
                path: "personal-details",
                name: "Salary Sacrifice Personal Details",
                component: SalarySacrificePersonalDetailsComponent,
                meta: {
                    title: "Personal Details - Origo",
                    scheme: "salsac",
                    nextPage: {
                        title: "Continue",
                        name: "Salary Sacrifice Product Details",
                    },
                },
            },

            // Product Details
            {
                path: "product-details",
                name: "Salary Sacrifice Product Details",
                component: SalarySacrificeProductDetailsComponent,
                meta: {
                    title: "Product Details - Origo",
                    scheme: "salsac",
                    nextPage: {
                        title: "Continue",
                        name: "Salary Sacrifice Order Details",
                    },
                },
            },

            // Order Details
            {
                path: "order-details",
                name: "Salary Sacrifice Order Details",
                component: SalarySacrificeOrderDetailsComponent,
                meta: {
                    title: "Finance & Product Information - Origo",
                    scheme: "salsac",
                    nextPage: {
                        title: "Submit Order",
                    },
                },
            },
        ],
    },

    // ECO / AMAPS Order Process
    {
        path: "/ecoamaps/order-process/:quoteId",
        name: "ECO / AMAPS Order Process",
        component: EcoAmapsOrderProcessComponent,

        children: [
            // Personal Details
            {
                path: "personal-details",
                name: "ECO / AMAPS Personal Details",
                component: EcoAmapsPersonalDetailsComponent,
                meta: {
                    title: "Personal Details - Origo",
                    scheme: "ecoamaps",
                    nextPage: {
                        title: "Continue",
                        name: "ECO / AMAPS Product Details",
                    },
                },
            },

            // Product Details
            {
                path: "product-details",
                name: "ECO / AMAPS Product Details",
                component: EcoAmapsProductDetailsComponent,
                meta: {
                    title: "Product Details - Origo",
                    scheme: "ecoamaps",
                    nextPage: {
                        title: "Continue",
                        name: "ECO / AMAPS Order Details",
                    },
                },
            },

            // Order Details
            {
                path: "order-details",
                name: "ECO / AMAPS Order Details",
                component: EcoAmapsOrderDetailsComponent,
                meta: {
                    title: "Finance & Product Information - Origo",
                    scheme: "ecoamaps",
                    nextPage: {
                        title: "Submit Order",
                    },
                },
            },
        ],
    },

    // Business contract hire order process
    {
        path: "/bch/order-process/:quoteId",
        name: "Business Contract Hire Order Process",
        component: BchOrderProcessComponent,

        children: [
            // Personal Details
            {
                path: "personal-details",
                name: "Business Contract Hire Personal Details",
                component: BchPersonalDetailsComponent,
                meta: {
                    title: "Personal Details - Origo",
                    scheme: "bch",
                    nextPage: {
                        title: "Continue",
                        name: "Business Contract Hire Product Details",
                    },
                },
            },

            // Product Details
            {
                path: "product-details",
                name: "Business Contract Hire Product Details",
                component: BchProductDetailsComponent,
                meta: {
                    title: "Product Details - Origo",
                    scheme: "bch",
                    nextPage: {
                        title: "Continue",
                        name: "Business Contract Hire Order Details",
                    },
                },
            },

            // Order Details
            {
                path: "order-details",
                name: "Business Contract Hire Order Details",
                component: BchOrderDetailsComponent,
                meta: {
                    title: "Finance & Product Information - Origo",
                    scheme: "bch",
                    nextPage: {
                        title: "Submit Order",
                    },
                },
            },
        ],
    },

    // FAQs
    {
        path: "/faqs",
        name: "FAQs",
        component: FAQsComponent,
        meta: {
            title: "FAQs - Origo",
            hideFooter: true,
        },
    },

    {
        path: "/my-vehicle/:contractId",
        name: "my-vehicle",
        component: MyVehicleComponent,
        meta: {
            title: "MyVehicle",
            hideFooter: true,
        },
    },

    // Order Status
    {
        path: "/order-status/:orderId",
        name: "Order Status",
        component: OrderStatusComponent,
        meta: {
            title: "Order Status",
            hideFooter: true,
        },
    },

    {
        path: "/:scheme/replacement-quotes",
        name: "Replacement Quotes",
        component: ReplacementQuotesComponent,
        meta: {
            title: "Replacement Quotes",
            hideFooter: true,
        },
    },

    // My Details and Documents
    {
        path: "/my-details-and-documents",
        name: "My Details and Documents",
        component: MyDetailsAndDocumentsComponent,
        meta: {
            title: "My Details and Documents - Origo",
            hideFooter: true,
        },
    },

    // View & Compare Your Shortlisted Vehicles
    {
        path: "/view-and-compare-your-shortlisted-vehicles",
        name: "View & Compare Your Shortlisted Vehicles",
        component: ViewAndCompareYourShortlistedVehiclesComponent,
        meta: {
            title: "View & Compare Your Shortlisted Vehicles - Origo",
        },
    },

    // Test Calculator
    {
        path: "/calculator",
        name: "Calculator",
        component: CalculatorComponent,
        meta: {
            title: "Test Calculator - Origo",
        },
    },

    // Default
    {
        path: "/:catchAll(.*)",
        redirect: "/login",
    },
];

/* const router = new Router({

    mode: 'history',
    base: '/',

    routes: routes,

    scrollBehavior(to, from, savedPosition) {
        document.getElementById('app').scrollTo({top: 0, behavior: 'smooth'});
        return {x: 0, y: 0}
    }

}); */

const router = createRouter({
    history: createWebHistory("/"),
    routes,
});

export default router;

const DEFAULT_TITLE = "Origo";

// router.beforeEach((to, from, next) => {
//     if (to.name !== 'Login' && router.app.session === null) next({name: 'Login'});
//     else next()
// });

router.afterEach((to, from) => {
    document.title = to.meta.title || DEFAULT_TITLE;
});
